<template>
  <div class="col pa-0">
    <Renderer
      v-for="(element, name) in subComponents"
      :key="name"
      v-model="form[name]"
      is-sub
      :element="element"
      :disable-group="disableGroup"
      @input="() => $emit('input', form)" />
  </div>
</template>

<script>
import Renderer from '@/components/form/Renderer.vue'

export default {
  components: {
    Renderer
  },
  props: {
    subComponents: {
      type: Object,
      required: true
    },
    disableGroup: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      form: {}
    }
  }
}
</script>
